import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class SenatorialDistrictFormData {
    @observable code = '';
    @observable name = '';
    @observable state_id: number|null = null;
    @observable is_active = true;
    @observable local_government_areas = [];
}

export class SenatorialDistrictForm extends CrudForm {
    modelName = 'SenatorialDistrict';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('local_government_areas', []);
                    }}
                />

                <Field
                    key={this.formStore.getValue('state_id')}
                    label="Local Government Areas"
                    name="local_government_areas"
                    component={Select}
                    multi={true}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.localGovernmentArea.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id')
                            }
                        });
                    }}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class SenatorialDistrictFilterForm {
    @observable state_id = null;
}

export class SenatorialDistrictList extends CrudList {
    modelName = 'SenatorialDistrict';

    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "name",
                label: "Senatorial Districts",
                sort: true,
            },
            {
                name: "code",
                label: "SD Code",
                sort: true,
            }
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        name="state_id"
                        placeholder="Select State"
                        component={Select}
                        loadOptions={api.state.getListAction}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class SenatorialDistrictPage extends CrudPage {
    modelName = 'SenatorialDistrict';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/SenatorialDistrictPage.tsx